<template>
  <div class="measuresCommContainer">
    <h6 v-if="AreIdsShown" style="background-color: red; color: lime">measuresCommContainer</h6>

    <div class="m-0 p-0" style="background: transparent; padding: 0px; overflow: auto; height: 175px; width: 30vw">
      <!-- <h5 v-show="AreIdsShown" style="background-color:darkblue;color:white;">OVERHAUL > currentPatientMeasuresComments Q: {{currentPatientMeasuresComments.length}}</h5> -->
      <!-- <h6 v-show="AreIdsShown" style="background-color:yellow;color:black;">  currentPatientMeasuresComments  Qty: {{currentPatientMeasuresComments.length}}</h6> -->
      <!-- <h5 v-show="AreIdsShown"  style="background-color:darkblue;color:yellow;">localPaComments {{localPaComments.length}}</h5> -->
      <!--  -->
      <!-- localPaComments {{ localPaComments }} -->

      <MeasureComment
        v-for="comment in props.comments"
        :comment="comment"
        :key="comment.commentId"
        class="comment-box"
        @edit-comment="sentMessageComments"
        @reply-comment="sentMessageComments"
        @delete-comment="sentMessageComments"
      />
    </div>

    <!-- <div class="m-0 p-0" style="overflow-y: auto;max-height:350px; "> -->
    <!-- <h5 style="background-color:darkblue;color:yellow;">localPaComments {{localPaComments.length}}</h5> -->
    <!-- <h5 style="background-color:black;color:cyan;">currentPatientMeasuresComments {{currentPatientMeasuresComments.length}}</h5> -->
    <!-- <h6 v-show="AreIdsShown" style="background-color:yellow;color:black;">MeasureComment</h6> -->
    <!-- <MeasureComment v-for="comment in localPaComments" :comment="comment" :key="comment.commentId" class="comment-box" @edit-comment="onEditComment" @reply-comment="onEditComment" @delete-comment="onEditComment" /> -->
    <!-- </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";

// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

import MeasureComment from "@/modules/Patient/MeasureComment.vue";

// & PROPS
const props = defineProps({
  comments: {
    type: Array,
    required: true,
    default: () => [],
  },
});

const AreIdsShown = ref(false);
// let localPaComments = ref([]);
//
// AreIdsShown: false,
// 			localPaComments: [],
// 			showTempHiddenControls: false,
// 			dataGridRefName: 'dataGrid',

function sentMessageComments(resp) {
// console.log("	 MEASURES       CommentsContainer  > Reply Edit Delete  onEditComment  ");
// console.log("RESPONSE");
// console.dir(resp);

  //todo RESP.payload === this.$store.state['comments'].papaComments

  // console.log(					'	STORE SETTER			ON EDIT COMMENT: >> 	resp  	setCurrentPatientMeasuresComments		(resp.payload '				)
  patientStore.setCurrentPatientMeasuresComments(resp.payload);

  // console.log('		STORE GET < currentPatientMeasuresComments  2 localPaComments')

  // console.log('                     BIND 2   localPaComments : ')

  // localPaComments = patientStore.currentPatientMeasuresComments.sort((a, b) => a.id > b.id)
  // console.log(' localPaComments : ')
  // console.dir(localPaComments)

  // console.log(' SORTING ........  currentPatientMeasuresComments   createdDate ')
  // this.localPaComments.sort((a, b) => a.id > b.id)
  // console.dir(this.localPaComments)
  //this.localPaComments.sort((a, b) => (a.dueDate > b.dueDate ? 1 : -1))
  //	this.localPaComments = this.$store.state['comments'].papaComments
}

onMounted(() => {
// console.log("onMounted() :      MeasuresCommentsContainer >>>>");

// console.log("props : ");
// console.log(props);
// console.log(" prop   comments ");
// console.log(props.comments);

  // this.$store.commit('setCurrentPatientMeasuresComments', this.comments)
  patientStore.setCurrentPatientMeasuresComments(props.comments);

  // console.log(' GETTer CHECK           currentPatientMeasuIresComments')
  // console.dir(this.currentPatientMeasuresComments)

  // this.localPaComments = patientStore.currentPatientMeasuresComments
  // this.localPaComments.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1))

  // localPaComments    = 	patientStore.currentPatientMeasuresComments.sort((a, b) => (a.createdDate < b.createdDate ? 1 : -1))
  // console.log('localPaComments')
  // console.log(localPaComments)
  // console.log('patientStore.currentPatientMeasuresComments')
  // console.log(patientStore.currentPatientMeasuresComments)
});
</script>

<style lang="scss" scoped>
.measuresCommContainer {
  padding: 0px;
}

.comment-box {
  margin-bottom: 2rem;
  // background: #b0c1b2;
}
</style>
